import { pickT } from "@repo/shared";
import { LineChart } from "@/components/charts/line-chart";
import { useBrandColor } from "@/lib/context/brand-color-context";
import type { HistoricalReturnSnapshot } from "@/lib/types/flow";
import { getRelativeTime } from "@/lib/utils";
import { T } from "./historical-return-widget.i18n";

type HistoricalReturnWidgetProps = {
  snapshot: HistoricalReturnSnapshot;
  language?: string;
};

export function HistoricalReturnWidget({
  snapshot,
  language = "en_GB",
}: HistoricalReturnWidgetProps) {
  const primaryColor = useBrandColor();
  const t = pickT(T, language);

  if (snapshot.timeseries.length === 0) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm text-muted-foreground">{t.noData}</p>
      </div>
    );
  }

  // Check if we have partial coverage
  const hasPartialCoverage =
    snapshot.coverage && snapshot.coverage.coveredProducts < snapshot.coverage.totalProducts;

  return (
    <div className="w-full space-y-4">
      <div className="w-full">
        <LineChart
          data={snapshot.timeseries}
          width="container"
          height={250}
          primaryColor={primaryColor ?? undefined}
          lang={language}
          extraYGridlines={1}
        />
      </div>
      <div className="text-xs text-muted-foreground">
        {hasPartialCoverage && (
          <div>{t.missingDataNote(String(Math.round(snapshot.coverage!.originalWeightPct)))}</div>
        )}
        <div>{t.snapshotTaken(getRelativeTime(snapshot.timestamp, language))}</div>
      </div>
    </div>
  );
}
